import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import emailValidate from "services/emailValidate";
// import validator from "validator";
import swal from "sweetalert";
import api from "services/api";
import { __ } from "services/Translator";

export default function ResendActivation(props) {
  // activation functionalities
  const history = useHistory();

  const [activationErrors, setActivationErrors] = useState({});
  const activationValidateForm = () => {
    var valid = true;
    var errorsTmp = {};
    if (activationData.email < 2 || activationData.email.length > 250) {
      errorsTmp = { ...errorsTmp, email: __("Please enter your email") };
      valid = false;
    }
    if (!emailValidate(activationData.email)) {
      errorsTmp = { ...errorsTmp, email: __("Your email not valid") };
      valid = false;
    }
    setActivationErrors(errorsTmp);
    return valid;
  };
  const updateActivationForm = (field, value) => {
    setActivationData({ ...activationData, [field]: value });
  };

  const [acceptActivationField, setAcceptActivationField] = useState({
    email: 0,
  });

  const activationInputChange = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    if (field == "email") {
      if (emailValidate(value)) {
        setAcceptActivationField({ ...acceptActivationField, email: 1 });
        setActivationErrors({ ...activationErrors, email: "" });
      } else {
        setAcceptActivationField({ ...acceptActivationField, email: 2 });
        setActivationErrors({
          ...activationErrors,
          email: __("Your email not valid"),
        });
      }
    }

    updateActivationForm(field, value);
  };

  const [activationData, setActivationData] = useState({
    email: "",
  });

  const activationAction = async (event) => {
    event.preventDefault();
    var valid = activationValidateForm();
    if (valid) {
      var response = await api.post("/activation", activationData);
      if (response.status === 200) {
        swal({
          title: __("Successfully sent!"),
          icon: "success",
        });
        history.push("/");
      } else {
        swal({
          title: response.data.message,
          icon: "warning",
        });
      }
    }
  };
  const autofocusName = (item) => {
    document.querySelector("#" + item).focus();
  };

  return (
    <>
      <div className="main_popup margin_top_60">
        <div className="container">
          <div className="modal-content ">
            <div className="reg_area">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="activation_area_img margin_top_30">
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/login-popup-bg.png?&dpr=1&format=auto&auto=format&w=435&h=496&max-age=2629056"
                    />
                  </div>

                  <div className="logo margin_bottom_30">
                    <img
                      src={
                        require("../../assets/images/new-landing/logo.png")
                          .default
                      }
                      alt="Card-Icon"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <form onSubmit={activationAction}>
                    <div className="form_area">
                      <div className="form_headline margin_bottom_15">
                        Resend Activation{" "}
                      </div>

                      <div className="form">
                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("email");
                              }}
                            >
                              {__("Your email")}
                            </div>
                            <input
                              value={activationData.email}
                              onChange={activationInputChange}
                              type="email"
                              name="email"
                              id="email"
                              className="input_box"
                            />
                            <div
                              className={
                                acceptActivationField.email == 0
                                  ? "icon "
                                  : acceptActivationField.email == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptActivationField.email == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">
                            {activationErrors.email}
                          </div>
                        </div>

                        <div className="submit_btn">
                          <button
                            type="submit"
                            className={
                              "angle_btn in_login " + props.landingType
                            }
                          >
                            Send
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="red"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
